// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateOtherSubjectBindingAdmin, UpdateOtherSubjectBindingAdminSchema } from 'api/gen/UpdateOtherSubjectBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOtherSubjectBindingAdminBaseObject, ValidateOtherSubjectBindingAdminBaseObjectSchema } from 'api/gen/ValidateOtherSubjectBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateOtherSubjectBindingAdmin'),
  binding: t.union([UpdateOtherSubjectBindingAdminSchema, t.null]),
});

export const ValidateUpdateOtherSubjectBindingAdminSchema = excess(t.intersection([ValidateOtherSubjectBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateOtherSubjectBindingAdmin extends t.TypeOf<typeof ValidateUpdateOtherSubjectBindingAdminSchema> {}
